var _module_exports = "<div class=\"fancy-menu-details-title\">Fill</div>\n<p>\n  Fills in missing values for MTS in the input stream.\n</p>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/app/analytics/block/FILL/description.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;